import { Routes, Route } from "react-router-dom";
import FilledFormList from "./FilledFormList";
import FilledFormForm from "./FilledFormForm";

const AssetTypeRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<FilledFormList />} />
      <Route path="/new" element={<FilledFormForm />} />
      <Route path="/view/:id" element={<FilledFormForm />} />
    </Routes>
  );
};

export default AssetTypeRoutes;
